<template>
  <div class="slcb-home__hero-wrap">
    <b-container class="slcb-home__hero-container">
      <h1 class="slcb-home__hero-title">Olá! Eu sou o Toddy <img src="../assets/img/hand.png" alt="Uma mão acenando amigávelmente"><br/>Seja bem vindo(a)!</h1>
      <p class="slcb-home__hero-text">Eu vou te ajudar a fazer o registro da sua marca ou na consulta do andamento de um processo já iniciado!</p>
      <div class="slcb-home__hero-start-toddy-container">
        <b-link href="/toddy" class="btn slcb-home__hero-start-toddy">Iniciar</b-link>
      </div>
    <div class="slcb-home__powered-by">
      <div class="slcb-home__link-group">
        CNPJ: 24.750.801/0001-32 -
        <b-link href="tel:+55 (51) 3028 1042" target="_blank" class="slcb-home__link slcb-home__link--phone">(51) 3028.1042</b-link> -
        <b-link href="mailto:contato@silvalopes.adv.br" target="_blank" class="slcb-home__link slcb-home__link--mail">contato@silvalopes.adv.br</b-link> -
        <b-link href="./static/files/termos_de_uso.pdf" target="_blank" download class="slcb-home__link slcb-home__link--file">Termos de uso</b-link>
      </div>
      Powered by <a target="_blank" href="http://mocka.site" class="slcb-home__link slcb-home__link--doted">Mocka</a>
    </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Home.vue